import { takeEvery, put, select } from 'redux-saga/effects';

import { targetUserSelector } from './selectors';
import { consts as getUserConsts } from '../profiles/get-user';
import { consts as getFamilyMemberConsts } from '../profiles/get-family-member';
import { consts as getProviderConsts } from '../profiles/get-provider';
import { consts as getProviderMemberConsts } from '../profiles/get-provider-member';
import { consts as getParentProviderConsts } from '../profiles/get-parent-provider';
import { consts as getUserProfileConst } from '../communities/getUserProfile';
import { consts as editPatientConsts } from '../profiles/edit-patient';
import { consts as editPatientByProviderConsts } from '../profiles/edit-patient-by-provider';
import { consts as editProviderConsts } from '../profiles/edit-provider';
import { consts as editUserConsts } from '../profiles/edit-user';
import { consts as changeSettingsConsts } from '../profiles/change-settings';
import { consts as invitations } from '../programs/invitations';
import { consts as upcomingSurveys } from '../surveys/upcoming';
import { consts as targetUserConsts } from './targetUser';
import { consts as contextConsts, isDefaultBehavior } from './index';
import chatConsts from '../chatConnection/constants';

/*
 * TODO:
 * - separate edit mode for logged and target user
 * - sidebar tabs changing error
 */

// actions
const GET_USER = getUserConsts.SUCCEED;
const GET_FAMILY_MEMBER = getFamilyMemberConsts.SUCCEED;
const GET_PROVIDER = getProviderConsts.SUCCEED;
const GET_PROVIDER_MEMBER = getProviderMemberConsts.SUCCEED;
const GET_PARENT_PROVIDER = getParentProviderConsts.SUCCEED;
const EDIT_PATIENT = editPatientConsts.SUCCEED;
const EDIT_PATIENT_BY_PROVIDER = editPatientByProviderConsts.SUCCEED;
const EDIT_PROVIDER = editProviderConsts.SUCCEED;
const EDIT_USER = editUserConsts.SUCCEED;
const EDIT_SETTINGS = changeSettingsConsts.SUCCEED;
const GET_USER_PROFILE = getUserProfileConst.SUCCEED;
// logout

// actions to clear data when target user changes completely
const CLEAR_ACTIONS = [
  invitations.CLEAR,
  upcomingSurveys.CLEAR,
  targetUserConsts.REMOVE,
];

const getUserAction = userType => {
  switch (userType) {
    case 'family-member':
      return getFamilyMemberConsts.SEND;
    case 'provider':
      return getProviderConsts.SEND;
    case 'provider-member':
      return getProviderMemberConsts.SEND;
    case 'parent-provider':
      return getParentProviderConsts.SEND;
    case 'user':
      return getUserProfileConst.SEND;
    case 'profile':
    default:
      return getUserConsts.SEND;
  }
};

/*
 * Saga for updating target user data to context/targetUser state
 */
function* updateTargetUserWorker(action) {
  yield put({
    type: targetUserConsts.UPDATE,
    payload: action.payload,
  });
}

export function* updateTargetUserSaga() {
  yield takeEvery(
    [
      EDIT_PATIENT,
      EDIT_PATIENT_BY_PROVIDER,
      EDIT_PROVIDER,
      EDIT_USER,
      EDIT_SETTINGS,
    ],
    updateTargetUserWorker,
  );
}

/*
 * Saga for setting target user data to context
 */
function* setTargetUserWorker(action) {
  yield put({
    type: targetUserConsts.SET,
    payload: action.payload,
  });
}

export function* setTargetUserSaga() {
  yield takeEvery(
    [
      GET_USER,
      GET_FAMILY_MEMBER,
      GET_PROVIDER,
      GET_PROVIDER_MEMBER,
      GET_PARENT_PROVIDER,
      GET_USER_PROFILE,
    ],
    setTargetUserWorker,
  );
}

/*
  Saga for fetching user profile when context.targetUserId is changed
 */

function* fetchTargetUserWorker(action) {
  const currentTargetUser = yield select(targetUserSelector);
  const defaultBehavior = isDefaultBehavior(action.payload);

  const id = defaultBehavior ? action.payload : action.payload.id;
  const userType = defaultBehavior ? 'profile' : action.payload.type;
  const userId = defaultBehavior ? null : action.payload.userId;

  if (currentTargetUser.id !== id) {
    yield CLEAR_ACTIONS.map(type => put({ type }));
  }

  if (id) {
    yield put({
      type: getUserAction(userType),
      payload: { userId, id },
    });
  } else {
    yield put({
      type: chatConsts.SOCIAL_CHAT_INIT_SELECTION,
    });
  }
}

export function* fetchTargetUserSaga() {
  yield takeEvery(contextConsts.SET_TARGET_USER_ID, fetchTargetUserWorker);
}



// WEBPACK FOOTER //
// ./src/redux/context/targetUserSagas.js